import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh',
          background: '#0a0a00', color: '#f5e6c8', fontFamily: 'sans-serif',
          padding: '2rem', textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
          <h2 style={{ color: '#c9960c', marginBottom: '0.5rem' }}>Algo ha salido mal</h2>
          <p style={{ color: '#a89070', marginBottom: '1.5rem' }}>
            Por favor, recarga la página. Si el problema persiste, contacta con soporte.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#c9960c', color: '#0a0a00', border: 'none',
              padding: '0.65rem 1.5rem', borderRadius: '8px', fontSize: '0.95rem',
              fontWeight: 700, cursor: 'pointer',
            }}
          >
            Recargar página
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              marginTop: '1.5rem', background: '#111', padding: '1rem',
              borderRadius: '6px', fontSize: '0.75rem', color: '#ef4444',
              maxWidth: '600px', overflowX: 'auto', textAlign: 'left',
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
